<div class="row mt-3">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12 d-flex justify-content-center">
        <tan-alert-message
          [errorType]="'info'"
          [message]="'Select the appropriate below option'"
        >
        </tan-alert-message>
      </div>
    </div>

    <ng-container>
      <div class="row justify-content-center">
        <div class="col-sm-12 d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-secondary ml-2 mr-2 mt-1 diagram-btn"
            [disabled]="reportLoading$ | async"
            (click)="emailReport()"
          >
            <i
              class="fa fa-spinner fa-spin mr-2"
              *ngIf="reportLoading$ | async"
            ></i>
            {{ (reportLoading$ | async) ? "Generating Report..." : "Email Report" }}
          </button>
          <!-- <button
            type="button"
            class="btn btn-secondary ml-2 mr-2 mt-1 diagram-btn"
            (click)="emailReportByRep()"
          >
            Report per Sales Rep
          </button> -->
        </div>
      </div>
    </ng-container>

    <tan-loader
      [loading]="reportLoading$ | async"
      [loadingText]="'<p>Generating and emailing report</p>'"
    >
    </tan-loader>

    <div class="row justify-content-center mt-3" *ngIf="reportError$ | async">
      <div class="col-sm-12 d-flex justify-content-center">
        <tan-alert-message
          [errorType]="'error'"
          [message]="'Could not generate the report. Please try again.'"
        ></tan-alert-message>
      </div>
    </div>

    <ng-container *ngIf="!(reportLoading$ | async) && !(reportError$ | async) && report">
      <div class="row justify-content-center mt-3">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message
            [errorType]="'success'"
            [message]="'Report emailed successfully'"
          ></tan-alert-message>
        </div>
      </div>

      <div class="row mt-3" *ngIf="report.period">
        <div class="col-sm-12 text-center">
          <h4 class="report-heading">Quote Summary</h4>
          <p class="report-period">
            <ng-container *ngIf="reportPeriodDays != null">
              Last {{ reportPeriodDays }}
              {{ reportPeriodDays === 1 ? "day" : "days" }} &mdash;
            </ng-container>
            {{ report.period.start_date | date: "dd MMM yyyy" }} to
            {{ report.period.end_date | date: "dd MMM yyyy" }}
          </p>
        </div>
      </div>

      <div class="row justify-content-center" *ngIf="report.totals">
        <div class="col-md-4 col-sm-6 mt-2">
          <div class="report-card text-center">
            <div class="report-card-value">{{ report.totals.created }}</div>
            <div class="report-card-label">Quotes Created</div>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mt-2">
          <div class="report-card text-center">
            <div class="report-card-value">{{ report.totals.approved }}</div>
            <div class="report-card-label">Quotes Approved</div>
          </div>
        </div>
      </div>

      <div class="row mt-4" *ngIf="report.quote_types?.length">
        <div class="col-sm-12">
          <div class="table-responsive">
            <table class="table table-bordered report-table">
              <thead>
                <tr>
                  <th>Quote Type</th>
                  <th class="text-center">Created</th>
                  <th class="text-center">Approved</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let quoteType of report.quote_types">
                  <tr class="report-type-row">
                    <td>{{ quoteType.label }}</td>
                    <td class="text-center">{{ quoteType.created }}</td>
                    <td class="text-center">{{ quoteType.approved }}</td>
                  </tr>
                  <tr *ngFor="let source of quoteType.sources" class="report-source-row">
                    <td class="pl-4">{{ source.label }}</td>
                    <td class="text-center">{{ source.created }}</td>
                    <td class="text-center">{{ source.approved }}</td>
                  </tr>
                </ng-container>
              </tbody>
              <tfoot *ngIf="report.totals">
                <tr class="report-total-row">
                  <td>Total</td>
                  <td class="text-center">{{ report.totals.created }}</td>
                  <td class="text-center">{{ report.totals.approved }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- 
<tan-modal
  #locations
  [size]="'md'"
  [title]="'Select Location for report'"
  [showInformationBlock]="false"
  (onSave)="emailLocationReport()"
>
  <div modal-content>
    <div class="container">
      <tan-loader
        [loading]="locationsLoading$ | async"
        [loadingText]="'<p>Loading Locations</p>'"
      >
      </tan-loader>

      <div class="row justify-content-center" *ngIf="locationsError$ | async">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message
            [errorType]="'error'"
            [message]="'Could not find Locations'"
          ></tan-alert-message>
        </div>
      </div>

      <div
        class="row"
        *ngIf="
          !(locationsError$ | async) &&
          !(locationsLoading$ | async) &&
          locations.length
        "
      >
        <div class="col-sm-12">
          <div class="">
            <form class="mt-3" [formGroup]="locationForm">
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="quote_location"
                  >Select Location</label
                >
                <select
                  class="form-control"
                  formControlName="quote_location"
                  id="quote_location"
                  (change)="setSelectedQuoteLocation()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let local of locations" [ngValue]="local.id">
                    {{ local.name }}
                  </option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal
  #reps
  [size]="'md'"
  [title]="'Select Sales rep for report'"
  [showInformationBlock]="false"
  (onSave)="emailRepReport()"
>
  <div modal-content>
    <div class="container">
      <tan-loader
        [loading]="repsLoading$ | async"
        [loadingText]="'<p>Loading Sales reps</p>'"
      >
      </tan-loader>

      <div class="row justify-content-center" *ngIf="repsError$ | async">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message
            [errorType]="'error'"
            [message]="'Could not find Sales Reps'"
          ></tan-alert-message>
        </div>
      </div>

      <div
        class="row"
        *ngIf="!(repsLoading$ | async) && !(repsError$ | async) && reps.length"
      >
        <div class="col-sm-12">
          <div class="">
            <form class="mt-3" [formGroup]="repForm">
              <div class="col-md-6 col-sm-12">
                <label class="control-label" for="rep">Select Sales Rep</label>
                <select
                  class="form-control"
                  formControlName="rep"
                  id="rep"
                  (change)="setSelectedQuoteRep()"
                >
                  <option [ngValue]="null">Please select</option>
                  <option *ngFor="let rep of reps" [ngValue]="rep.id">
                    {{ rep.user.firstName }} {{ rep.user.lastName }}
                  </option>
                </select>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</tan-modal> -->
